// Custom code: sibling swatches

import { Component } from '@theme/component';

class SiblingSwatchesComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    // Cache any parent product card
    this.parentProductCard = this.closest('product-card');
    if (this.parentProductCard) {
      this.swatchesForm = this.querySelector("form");
      this.swatchesForm.addEventListener("change", this.#handleProductUpdate.bind(this));
    }
  }

  /**
   * Updates the card URL and images when a product is selected.
   */
  #handleProductUpdate(event) {
    const isSwatchInput = event.target instanceof HTMLInputElement && event.target.name?.includes('-sibling-swatch');
    const clickedSwatch = event.target;

    event.stopPropagation();

    if (isSwatchInput && this.parentProductCard) {
      const { productCardLink, productTitleLink, cardGalleryLink, slideshow } = this.parentProductCard.refs;

      if (productCardLink) {
        productCardLink.href = clickedSwatch.dataset.productUrl;
      }
      if (productTitleLink) {
        productTitleLink.href = clickedSwatch.dataset.productUrl;
      }
      if (cardGalleryLink) {
        cardGalleryLink.href = clickedSwatch.dataset.productUrl;
      }

      const selectedMediaId = clickedSwatch.dataset.mediaId;
      console.log(slideshow, selectedMediaId)
      if (slideshow && selectedMediaId) {
        slideshow.select({ id: selectedMediaId }, undefined, { animate: false });
      }
    }


    // TODO: PDP
  }

  /**
   * Override the variantChanged method to handle unavailable swatches with available alternatives.
   * @param {Event} event - The variant change event.
   */
  // variantChanged(event) {
  //   if (!(event.target instanceof HTMLElement)) return;

  //   // Check if this is a swatch input
  //   const isSwatchInput = event.target instanceof HTMLInputElement && event.target.name?.includes('-swatch');
  //   const clickedSwatch = event.target;
  //   const availableCount = parseInt(clickedSwatch.dataset.availableCount || '0');
  //   const firstAvailableVariantId = clickedSwatch.dataset.firstAvailableOrFirstVariantId;

  //   // For swatch inputs, check if we need special handling
  //   if (isSwatchInput && availableCount > 0 && firstAvailableVariantId) {
  //     // If this is an unavailable variant but there are available alternatives
  //     // Prevent the default handling
  //     event.stopPropagation();

  //     // Update the selected option visually
  //     this.updateSelectedOption(clickedSwatch);


  //     // Use parent's fetch method
  //     this.fetchUpdatedSection(requestUrl);
  //     return;
  //   }

  //   // For all other cases, use the default behavior
  //   super.variantChanged(event);
  // }
}

if (!customElements.get('sibling-swatches-component')) {
  customElements.define('sibling-swatches-component', SiblingSwatchesComponent);
}
